import { trpc } from '@/utils/trpc'

export const useTimeSavedCounter = () => {
  const { data, isLoading } = trpc.getTimeSavedCounter.useQuery(undefined, {
    refetchOnWindowFocus: false,
  })

  return { data, isLoading }
}
